import { Path, useSearchParams } from 'react-router';

const buildPathWithParams = ({
  path,
  searchParams,
}: {
  path: string | Partial<Path>;
  searchParams: URLSearchParams;
}) => {
  const searchParamsString = searchParams.toString();

  if (searchParamsString === '') {
    return path;
  }

  if (typeof path === 'string') {
    const [base, existingQuery] = path.split('?');
    const merged = new URLSearchParams(existingQuery);
    searchParams.forEach((value, key) => {
      if (!merged.has(key)) {
        merged.append(key, value);
      }
    });
    return `${base}?${merged.toString()}`;
  }

  return `${path}?${searchParamsString}`;
};

/**
 * Builds a path, appending the current search params to the new path.
 */
export const usePathWithParams = () => {
  const [searchParams] = useSearchParams();

  return ({ to }: { to: string | Partial<Path> }) =>
    buildPathWithParams({ path: to, searchParams });
};
